import React from 'react';
import { ProductData } from '../../../Shared/Interfaces.ts';

import './ProductCard.less';
import { TrackModalClose } from '../../../Shared/Tracking.ts';

interface ProductCardProps {
  product: ProductData;
  setProducts: React.Dispatch<React.SetStateAction<ProductData[]>>;
}

const ProductCard = ({ product, setProducts }: ProductCardProps) => {
  const remove = () => {
    let subcategoryId = window._THULEDATA.ComparisonModal.SubcategoryId;
    let productDataJson = localStorage.getItem(subcategoryId);

    if (!productDataJson) return;

    let comparisonList: string[] = JSON.parse(productDataJson);
    let updatedList = comparisonList.filter((id) => id !== product.productId);

    if (updatedList.length === 0) {
      localStorage.removeItem(subcategoryId);
    } else {
      localStorage.setItem(subcategoryId, JSON.stringify(updatedList));
    }

    document.dispatchEvent(new Event('comparisonModalProductRemoved'));

    setProducts((x) => {
      let products = x.filter((y) => y.productId != product.productId);
      if (x.length > 1 && products.length < 2) TrackModalClose(true);

      return products;
    });
  };

  return (
    <div className="product">
      <img className="ms-4 my-3" src={product?.image?.src} alt={product?.image?.alt}></img>
      <h6 className="product-name m-0">{product?.webTitle1}</h6>
      <i className="le-icon-x" role="button" onClick={remove}></i>
    </div>
  );
};

export default ProductCard;
